import React, { useEffect, useState } from 'react';
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ImageIcon from "@mui/icons-material/Image";
import HomePromptExample from '../componets/HomePromptExample';
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VerifiedIcon from "@mui/icons-material/Verified";
import PeopleIcon from "@mui/icons-material/People";
import UploadIcon from "@mui/icons-material/Upload";
import { Link } from 'react-router-dom';
import { title } from '../config/config';
import SEO from '../config/SEO';
import { Instagram } from '@mui/icons-material';
import { blogListUrl, formatFollowers } from '../utils/Universalfunctions';
import BlogCard from './Blogs_page/BlogCard';
import { collection, getCountFromServer, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';
import Community from './Community';
import CategorySection from '../componets/Homepages/CategorySection';
import { categoryAll } from '../Datas/categoryPosts';
import HomeImageGeneratorSection from '../componets/HomeImageGeneratorSection';



const steps = [
     {
          icon: <LightbulbIcon fontSize="large" color="primary" />,
          title: "Choose a Prompt Type",
          description: "Select the type of image you want: Portrait, Anime, Logo, Landscape, and more.",
          btnpreview: false
     },
     {
          icon: <ContentCopyIcon fontSize="large" color="primary" />,
          title: "Copy a Ready Prompt",
          description: "Pick from curated prompts crafted by top AI creators and copy it in one click.",
          btnpreview: false
     },
     {
          icon: <ImageIcon fontSize="large" color="primary" />,
          title: "Generate Your AI Image",
          description: "Paste the prompt in your favorite AI tool and create stunning images instantly.",
          btnpreview: false
     },
     {
          icon: <Instagram fontSize="large" color="primary" />,
          title: "Follow on Instagram",
          description: "Exclusive UI, web projects, AI hacks & daily design posts — join us on Instagram 🔥",
          btnpreview: true,
          btn: {
               label: "Follow Now",
               link: "https://www.instagram.com/heyprompt.online"
          }
     }

];



const features = [
     {
          icon: <EmojiObjectsIcon />,
          title: "Curated Prompts",
          text: "High-quality prompts curated by top AI creators.",
     },
     {
          icon: <AccessTimeIcon />,
          title: "Save Time",
          text: "Instantly copy ready-to-use prompts and skip trial & error.",
     },
     {
          icon: <VerifiedIcon />,
          title: "AI Verified",
          text: "Prompts tested and optimized for best results.",
     },
     {
          icon: <PeopleIcon />,
          title: "Community",
          text: "Join a growing community of AI artists & enthusiasts. ",
     },
];

const Index = () => {


     const [prompts, setPrompts] = useState([]);

     useEffect(() => {
          const fetchPrompts = async () => {
               const querySnapshot = await getDocs(collection(db, "prompts"));
               const list = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
               setPrompts(list);
          };

          fetchPrompts();
     }, []);


     // Blog Data Fetching & State
     const [blogdata, setBlogData] = useState([]);
     const [totalUsers, setTotalUsers] = useState(0);

     useEffect(() => {

          fetch(blogListUrl).then(res => res.json()).then(result => setBlogData(result.reverse()));

          const fetchUsers = async () => {
               const coll = collection(db, "users");
               const snapshot = await getCountFromServer(coll);
               setTotalUsers(snapshot.data().count);
          };

          fetchUsers();

     }, []);





     return (
          <>

               <SEO
                    title="Free AI Prompts for ChatGPT, Gemini & Midjourney etc"
                    description="Explore thousands of powerful AI prompts for ChatGPT, Google Gemini, Midjourney, Claude and more. Copy-paste prompts for AI images, SEO content, marketing, Instagram reels and automation."
                    keywords="AI prompts, free AI prompts, ChatGPT prompts, Gemini prompts, Midjourney prompts, best AI prompts 2026, prompt engineering, AI image prompts, AI art prompts, copy paste prompts, prompt library, prompt marketplace, viral AI prompts, Instagram reel prompts, SEO prompts, marketing prompts, logo prompts, AI content prompts, trending AI prompts"
                    canonicalPath="/"
               />

               <section className='banner'>
                    <div className='__container'>
                         <div className="hero__text">
                              {/* <p className="hero__subtitle">Share the prompts behind the art.</p> */}
                              <p className="hero__subtitle">The #1 website for prompt library</p>

                              <h1 className="hero__title">
                                   Free AI Prompts & AI Image Generator for ChatGPT, Gemini, Midjourney & More <span>HeyPrompt</span>
                              </h1>

                              <p className="hero__description">
                                   Discover free and premium AI prompts for ChatGPT, Gemini, Claude, and more. Generate, copy, and explore proven prompts on HeyPrompt to create better AI results.
                              </p>

                              <div className="hero__niche">
                                   <div className="stat-card">
                                        <div className="stat-card__number">+{prompts?.length || 0}</div>
                                        <div className="stat-card__label">Total Prompts</div>
                                   </div>

                                   <div className="stat-card">
                                        <div className="stat-card__number">+{formatFollowers(totalUsers) || 0}</div>
                                        <div className="stat-card__label">Total Active User</div>
                                   </div>

                                   <div className="stat-card">
                                        <div className="stat-card__number">Free & Paid</div>
                                        <div className="stat-card__label">Create. Share. Inspire!</div>
                                   </div>

                              </div>
                         </div>

                    </div>
               </section>

               <HomeImageGeneratorSection/>



               <section className="how-it-works">
                    <div className='__container'>

                         {/* <h2 className="heading">How It Works</h2> */}
                         <div className="row">
                              {steps.map((step, index) => (
                                   <div className="col-md-3 col-lg-3 col-6" key={index}>
                                        <div className="card">
                                             {step.icon}
                                             <h3 className="title">{step.title}</h3>
                                             <p className="text">{step.text}</p>
                                             {step?.btnpreview &&
                                                  <Link
                                                       to="https://www.instagram.com/heyprompt.online"
                                                       target="_blank"
                                                       className="btn-follow"
                                                  >
                                                       Follow Now
                                                  </Link>
                                             }
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </div>

               </section>

               <HomePromptExample />

               <CategorySection categories={categoryAll} />




               <section className="why-hey-prompt">
                    <div className='__container'>
                         <h1> Why {title}? </h1>
                         <p>
                              {title} helps you discover, copy, and create stunning AI images effortlessly. Explore curated prompts,
                              save time, and join a growing community of AI artists and enthusiasts shaping the future of generative art.
                         </p>
                         <div className="row">
                              {features.map((feature, index) => (
                                   <div className="col-md-3 col-lg-3 col-sm-6" key={index}>
                                        <div className="cardkld3">
                                             <div className="mb-3">{feature.icon}</div>
                                             <h5 className="mb-2">{feature.title}</h5>
                                             <p className="mb-0">{feature.text}</p>
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </div>
               </section>

               <section className="index-blog-section">
                    <div className="__heyprompt-blog">
                         <div className="__container">
                              <div className="blog-list-page">
                                   <h1 className="page-title">Blogs - AI Prompts, Tools & Tutorials</h1>
                                   <p className="page-paragraph mb-4">The HeyPrompt Blog helps creators, developers, and AI users learn how to work smarter with artificial intelligence. We publish practical guides, tutorials, and workflows that make prompt engineering, content automation, and productivity tools easier to understand and apply in real projects.</p>
                                   <Link to="/blogs" className="view-more-btn">
                                        View All Blogs
                                   </Link>

                                   <div className="row row-gap-4">
                                        {blogdata.length === 0 &&
                                             <div className="col-12 text-center">
                                                  <h5> Blogs Not found</h5>
                                             </div>
                                        }
                                        {blogdata.slice(0, 3).map((post, i) => (
                                             <BlogCard key={i} post={post} />
                                        ))}
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>

               <Community />

               <section className="community-section">
                    <div className='__container'>
                         <div className="row">
                              <div className="col-12">
                                   <h6>Community Resources</h6>
                                   <h2>Sell your prompts & earn money</h2>
                                   <p>
                                        {title} exists to make the craft behind AI visuals transparent.
                                        We publish settings, pacing notes, and lessons learned so everyone -
                                        from curious fans to pro creators can turn inspiration into their own story.
                                   </p>

                                   <p>
                                        Submit your prompt and teach the community. Send your latest render
                                        with the prompt, settings, and story behind it. We feature the most
                                        helpful breakdowns and credit every creator.
                                   </p>

                                   <Link to="/marketplace" className="submit-btn">
                                        <UploadIcon /> Submit Prompt
                                   </Link>
                              </div>
                         </div>
                    </div>
               </section>




          </>
     );
}

export default Index;
